import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 20, height: 20, rx: 10, stroke: "#15020C" }), /* @__PURE__ */ React.createElement("rect", { x: 5.5, y: 5.5, width: 10, height: 10, rx: 4.5, fill: "#15020C" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
